<div class="lmo-frac-fcpo-manage-id" *ngIf="existingFcpo$ | async as existingFcpo">
  <div class="content">
    <div class="flex flex-col">
      <div class="flex flex-row items-center justify-between">
        <div class="mr-1">
          <button
            mat-stroked-button
            *ngIf="existingFcpo.purchaseOrder.pausedTimestamp === null; else unpause"
            (click)="promptPause()"
          >
            Pause
          </button>
          <ng-template #unpause>
            <button mat-stroked-button (click)="unpausePO()">Unpause</button>
          </ng-template>
        </div>
        <button class="remove-po" mat-stroked-button color="warn" (click)="removePo()">Remove</button>
      </div>
      <div>
        <h2>{{ existingFcpo?.purchaseOrder.mineName }}</h2>
      </div>
    </div>
    <h4>{{ existingFcpo?.purchaseOrder.meshType }} Mesh for {{ currentFracName$ | async }}</h4>
    <mat-form-field>
      <mat-label> Purchase Order</mat-label>
      <mat-select [formControl]="selectedPo" [compareWith]="compareById">
        <mat-select-trigger>
          {{ selectedPo?.value?.name || 'Select' }}
          <ng-container *ngIf="selectedPo?.value?.blanketAllocations?.length">(Blanket)</ng-container>
        </mat-select-trigger>
        <mat-option *ngFor="let po of meshPos$ | async; trackBy: trackById" [value]="po">
          <div class="po-container">
            <div class="po-header">
              <span class="name"
                >{{ po.name }} <ng-container *ngIf="po.blanketAllocations?.length">(Blanket)</ng-container></span
              >
              <span class="opened-date">Opened {{ po.createdTimestamp | date: 'shortDate' }}</span>
            </div>
            <div class="po-body">{{ floor(calculatePoRemaining(po) / 2000) | number: '1.0-0' }} tons remaining</div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-grid-list
    *ngIf="existingFcpo.purchaseOrder.uploadedFiles && existingFcpo.purchaseOrder.uploadedFiles.length > 0"
    cols="2"
    rowHeight="3:2"
  >
    <mat-grid-tile *ngFor="let file of existingFcpo.purchaseOrder.uploadedFiles">
      <div class="image-preview">
        <img [src]="file.url" *ngIf="isImage(file.fileName); else noPreview" (click)="openInWindow(file.url)" />
        <ng-template #noPreview>
          <div class="preview-placeholder" (click)="openInWindow(file.url)">
            <h3>{{ file.fileName }}</h3>
          </div>
        </ng-template>
        <span
          class="material-icons"
          [matTooltip]="'Delete'"
          (click)="deleteAttachment(file.id, existingFcpo.purchaseOrder.id, existingFcpo.fracClusterId)"
          >close</span
        >
      </div>
    </mat-grid-tile>
  </mat-grid-list>
  <form [formGroup]="editPoForm" class="content" (ngSubmit)="updatePo()">
    <div class="details-row">
      <h3>Details</h3>
      <label>
        <input
          class="upload-button"
          [disabled]="uploadingPOAttachment$$.asObservable() | async"
          (change)="onFileChange($event, existingFcpo)"
          type="file"
          accept="application/pdf, image/*"
        />
        <span class="material-icons">cloud_upload</span>
        <span *ngIf="!(uploadingPOAttachment$$.asObservable() | async)">Upload Attachments</span>
        <span *ngIf="uploadingPOAttachment$$.asObservable() | async">Uploading...</span>
      </label>
    </div>
    <div class="relative" *saFeatureFlag="'blanketPOs'">
      <div class="border-2 border-red-500 p-2">
        <div>
          A note from the devs: This is only visible to internal people right now. If anyone else edits a PO, it should
          just keep the existing settings.
        </div>
        <div class="font-bold my-1">
          There is no way to turn off a blanket PO atm, once you blanket it, you will need a dev to turn it off
        </div>
        <div class="font-bold my-1">
          The frac list is not "smart" yet and just shows ALL THE FRACS, even if they don't use that mesh
        </div>
      </div>
      <mat-slide-toggle formControlName="isBlanket" color="primary">Blanket</mat-slide-toggle>
      <ng-container *ngIf="editPoForm.get('isBlanket').value">
        <div class="flex justify-end">
          <button mat-mini-fab (click)="addBlanketAllocation()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div
          *ngFor="let control of $any(editPoForm.get('blanketAllocations')).controls; let i = index"
          class="py-2 flex items-center justify-between"
        >
          <div class="flex items-center justify-start">
            <button mat-mini-fab color="warn" (click)="removeBlanketAllocation(i)">
              <mat-icon>delete</mat-icon>
            </button>
            <ng-container *ngIf="control.get('fracId').value; else selectFrac">
              <div class="ml-1">{{ control.get('fracId').value | fracNameFromId$ | async }}</div>
            </ng-container>
            <ng-template #selectFrac>
              <mat-form-field>
                <mat-label>Select a Frac</mat-label>
                <mat-select [formControl]="control.get('fracId')">
                  <mat-option
                    *ngFor="let frac of fracListForBlanketPO$ | async; trackBy: trackById"
                    [value]="frac.lmoFracSummary.id"
                    >{{ frac.lmoFracSummary.name }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </ng-template>
          </div>
          <div>
            <mat-form-field class="form-field">
              <input
                matInput
                placeholder="Tonnage"
                [formControl]="control.get('allocationTonnage')"
                autocomplete="off"
                sa-number-input
              />
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </div>
    <mat-form-field class="form-field">
      <input matInput placeholder="Total Tonnage" formControlName="totalTonnage" autocomplete="off" sa-number-input />
    </mat-form-field>
    <div class="form-row">
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Daily Min (Tons)"
          formControlName="dailyMinTon"
          autocomplete="off"
          sa-number-input
        />
      </mat-form-field>
      <div class="spacer"></div>
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Daily Max (Tons)"
          formControlName="dailyMaxTon"
          autocomplete="off"
          sa-number-input
        />
      </mat-form-field>
    </div>
    <mat-form-field class="form-field">
      <input matInput placeholder="Cost Per Ton" formControlName="costPerTon" autocomplete="off" saCurrencyInput />
    </mat-form-field>
    <mat-form-field class="form-field">
      <input
        matInput
        class="datepicker-input"
        placeholder="Reset daily allocation time"
        autocomplete="off"
        formControlName="resetAllocationTime"
        [owlDateTime]="resetAllocationTime"
        [owlDateTimeTrigger]="resetAllocationTime"
      />
      <owl-date-time #resetAllocationTime [pickerType]="'timer'"></owl-date-time>
    </mat-form-field>
    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Billable Mileage"
        [formControl]="billableMileage"
        autocomplete="off"
        type="number"
        min="0"
      />
    </mat-form-field>
    <div style="margin-top: -15px;" *ngIf="showApplyToCompletedOrdersToggle$.value">
      <mat-slide-toggle class="text-xs" formControlName="applyToCompletedOrder" color="primary"
        >Apply to all completed orders out of this loader for this frac?</mat-slide-toggle
      >
    </div>
    <mat-form-field class="form-field" *saFeatureFlag="'defaultLoadWeightInput'">
      <input
        matInput
        placeholder="Default Load Weight"
        [formControl]="defaultLoadWeight"
        autocomplete="off"
        sa-number-input
      />
      <mat-hint
        >Most of the time this should be left blank. This is used when city/state/county regulations require running
        lighter loads (Due to Frost Laws, Spring melt, etc)
      </mat-hint>
    </mat-form-field>
    <div class="h-2"></div>

    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="PO Line Item Number"
        [formControl]="poLineItemNumber"
        [required]="isPOLineItemNumberMandatory"
        autocomplete="off"
        type="text"
        min="0"
      />
      <mat-hint *ngIf="isPOLineItemNumberMandatory">PO Line Item Number is Required</mat-hint>
    </mat-form-field>

    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Percent Based Allocation"
        [formControl]="percentBasedAutoOrderingAllocation"
        autocomplete="off"
        type="text"
        min="0"
        sa-number-input
      />
    </mat-form-field>

    <mat-form-field class="form-field subscribed-users" *saFeatureFlag="'purchaseOrderAllocationNotifications'">
      <mat-select
        formControlName="subscribedSandiUsers"
        placeholder="Subscribed Users"
        multiple
        saAutomatedSelector="well-creation__subscribed-users"
      >
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="'Subscribed Users'"
            [noEntriesFoundLabel]="'No User found'"
            [formControl]="filterUser"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let user of filteredUsers$ | async; trackBy: filteredUsers$ | trackByKey: 'id'"
          [value]="user.id"
        >
          <span>{{ user.name }}</span>
        </mat-option>
      </mat-select>
      <mat-hint>Select which users will receive notifications when this PO is nearing or over capacity. </mat-hint>
    </mat-form-field>

    <mat-form-field *ngIf="isGroupedAccountUser$ | async" class="form-field" style="margin-top: 24px;">
      <mat-label>Permitted Fracs (leave blank for all)</mat-label>
      <mat-select formControlName="permittedFracIds" multiple>
        <mat-option *ngFor="let frac of fracList$ | async; trackBy: trackById" [value]="frac.lmoFracSummary.id">{{
          frac.lmoFracSummary.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button *ngIf="!updatingPO$.value" type="submit" mat-raised-button color="primary">
      Save
    </button>
    <button *ngIf="updatingPO$.value" type="button" mat-raised-button color="primary" disabled>
      <span class="loading-dots text-gray-700">Updating purchase order, please wait...</span>
    </button>
  </form>
</div>

<ng-template #confirmCancel>
  <ng-container *ngIf="existingFcpo$ | async as fcpo">
    <h1 mat-dialog-title>Remove Purchase Order</h1>
    <div mat-dialog-content>
      <p>Are you sure you want to remove this purchase order from {{ currentFracName$ | async }}?</p>
      <p class="auto-assignment-warning" *ngIf="autoPurchaseOrderAssignment$ | async">
        NOTE:<br />This frac currently has <strong>Purchase Order Auto-Assignment</strong> turned on. If you remove this
        purchase order, we will not auto assign it to <strong>{{ currentFracName$ | async }}</strong> again
      </p>
    </div>
    <div mat-dialog-actions class="actions">
      <button mat-button [mat-dialog-close]="false" color="primary">Cancel</button>
      <button mat-button [mat-dialog-close]="true" color="warn">Remove</button>
    </div>
  </ng-container>
</ng-template>

<ng-template #defaultLoadWeightWarning>
  <div mat-dialog-title>
    Confirm Default Load Weight
  </div>
  <div mat-dialog-content>
    You have entered a default load weight
    <span class="font-semibold">({{ defaultLoadWeight.value | number }} lbs)</span> which is less than half of the
    expected load weight, are you sure you wish to proceed?
  </div>
  <div mat-dialog-actions class="flex justify-between">
    <button mat-stroked-button [matDialogClose]="false">Go Back</button>
    <button mat-raised-button color="warn" [matDialogClose]="true">Save Anyway</button>
  </div>
</ng-template>
<ng-template #billableMilageApplySameMineApplyToCompletedOrders>
  <div class="mb-2">
    <div mat-dialog-title>
      Do you want the billable mileage to be updated to {{ billableMileage.value | number }} miles for future orders, as
      well as apply the changes to past completed orders? This change will apply to other purchase orders on this frac
      originating from the same mine.
    </div>
    <div mat-dialog-actions class="flex justify-between">
      <button mat-stroked-button [matDialogClose]="false">Cancel</button>
      <button mat-raised-button color="warn" [matDialogClose]="true">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #billableMilageApplySameMineNotApplyToCompletedOrders>
  <div class="mb-2">
    <div mat-dialog-title>
      Do you want the billable mileage to be updated to {{ billableMileage.value | number }} miles for future orders?
      This change will apply to other purchase orders on this frac originating from the same mine.
    </div>
    <div mat-dialog-actions class="flex justify-between">
      <button mat-stroked-button [matDialogClose]="false">Cancel</button>
      <button mat-raised-button color="warn" [matDialogClose]="true">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #billableMilageNotApplyToCompletedOrders>
  <div class="mb-2">
    <div mat-dialog-title>
      Do you want the billable mileage to be updated to {{ billableMileage.value | number }} miles for future orders?
    </div>
    <div mat-dialog-actions class="flex justify-between">
      <button mat-stroked-button [matDialogClose]="false">Cancel</button>
      <button mat-raised-button color="warn" [matDialogClose]="true">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #billableMilageApplyToCompletedOrders>
  <div class="mb-2">
    <div mat-dialog-title>
      Do you want the billable mileage to be updated to {{ billableMileage.value | number }} miles for future orders, as
      well as apply the changes to past completed orders?
    </div>
    <div mat-dialog-actions class="flex justify-between">
      <button mat-stroked-button [matDialogClose]="false">Cancel</button>
      <button mat-raised-button color="warn" [matDialogClose]="true">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #pauseDescription>
  <div mat-dialog-title>
    Pause Reason
  </div>
  <div mat-dialog-content>
    <div class="flex flex-col w-full">
      <div>Please enter reason for pause</div>
      <div class="w-full">
        <mat-form-field class="w-full">
          <mat-label>Pause Reason</mat-label>
          <textarea matInput [formControl]="pauseReason"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="flex justify-between">
    <button mat-stroked-button>Cancel</button>
    <button mat-raised-button color="warn" (click)="pausePO()" mat-dialog-close>Pause PO</button>
  </div>
</ng-template>
